import type { ReactNode } from 'react';

interface PageHeaderProps {
  title: string;
  description?: string;
  action?: ReactNode;
}

export function PageHeader({ title, description, action }: PageHeaderProps) {
  return (
    <header className="mb-8 flex items-start justify-between gap-6">
      <div>
        <h1 className="text-page-title font-semibold text-content">{title}</h1>
        {description ? (
          <p className="mt-2 max-w-prose text-body text-content-secondary">{description}</p>
        ) : null}
      </div>
      {action ? <div className="shrink-0">{action}</div> : null}
    </header>
  );
}
